import { render } from "./MergeItems.vue?vue&type=template&id=07e11d2e"
import script from "./MergeItems.vue?vue&type=script&lang=js"
export * from "./MergeItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__